import ApolloClient from 'apollo-boost';
// eslint-disable-next-line no-unused-vars
import fetch from 'isomorphic-fetch';

export const client = new ApolloClient({
  uri: 'https://edge.weboxit.com/api/graphql',
});
